<div class="container">
  <ds-button id="openSearch" class="ellipsis-search" shape="rounded" size="medium" type="secondary" variant="label-icon" icon="search" [label]="searchValue"
    iconPosition="right" iconStyle="material-icons-outlined" (onClick)="openSearch()">
  </ds-button>
  <ds-button id="clearAllFilters" *appIsDesktop class="clearAllFilters" size="medium" type="tertiary" variant="label-only" [label]="appStrings.accounts_clearFilters"
    iconPosition="left" iconStyle="material-icons" (onClick)="handleClearAll()" [isDisabled]="disableClearAll">
  </ds-button>
</div>